<script setup lang="ts">
import {reactive} from "vue";
import {inviteUser} from "@/Services/Admin/admin-users";
import {saving} from "@/Composables/api";
import {Button, Dialog, InputText, Label} from "@/Components/Library";
import {MainStore, useMainStore} from "@/Stores/store";

const $store = useMainStore<MainStore>();

const model = defineModel<boolean>("visible");

const defaultForm = {
    first_name: null,
    last_name: null,
    email: null,
};
const userInvite = reactive({
    ...defaultForm,
});

const save = async () => {
    await inviteUser(userInvite);
    $store.toastMessages.push({
        severity: "success",
        summary: "Success",
        detail: "User invited successfully",
        life: 3000,
    });
    setTimeout(() => {
        model.value = false;
        Object.assign(userInvite, defaultForm);
    }, 3000);
};
</script>
<template>
    <Dialog
        v-model:visible="model"
        modal
        header="Invite user"
        class="mx-8 max-h-dvh w-full overflow-y-auto sm:max-w-sm"
    >
        <form class="flex flex-col" @submit.prevent="save">
            <div class="mb-4">
                <div class="mb-4 flex flex-col">
                    <Label for="first_name" class="mb-1" required>First Name</Label>
                    <InputText
                        id="first_name"
                        name="first_name"
                        placeholder="First Name"
                        type="text"
                        required
                        autofocus
                        autocomplete="first_name"
                        fluid
                        v-model="userInvite.first_name"
                    />
                </div>
                <div class="mb-4 flex flex-col">
                    <Label for="last_name" class="mb-1" required>Last Name</Label>
                    <InputText
                        id="last_name"
                        name="last_name"
                        placeholder="Last Name"
                        type="text"
                        required
                        autofocus
                        autocomplete="last_name"
                        fluid
                        v-model="userInvite.last_name"
                    />
                </div>
                <div class="flex flex-col">
                    <Label for="email" class="mb-1" required>Email</Label>
                    <InputText
                        id="email"
                        name="email"
                        type="email"
                        placeholder="Email"
                        required
                        autocomplete="username"
                        fluid
                        v-model="userInvite.email"
                    />
                </div>
            </div>
            <Button :loading="!!saving" class="bg-askr-green text-white" type="submit">Add</Button>
        </form>
    </Dialog>
</template>
<style scoped></style>
